module.exports = __webpack_public_path__ + "static/media/conveyorbelt_118075.1a47dd57.png";